import brackgroundImageGradient from "../../assets/bradesco/background-image-gradient.svg";

export const bradescoTheme = {
  white: "#fff",

  black: {
    950: "#000",
    900: "#212121",
    800: "#424242",
    700: "#616161",
    600: "#757575",
    500: "#9e9e9e",
    400: "#bdbdbd",
    300: "#e0e0e0",
    200: "#eeeeee",
    100: "#f5f5f5",
    50: "#fafafa",
  },

  colors: {
    primary: "#fff",
    secondary: "#000",
    tertiary: "#0000EE",
  },

  backgrounds: {
    defaultGradient: "linear-gradient(87deg, #CC092F 52.60%, #B81570 100%)",
  },

  backgroundsImages: {
    default: brackgroundImageGradient,
  },

  typography: {
    fontFamily: {
      primary: "Bradesco Sans",
      secondary: "Poppins, sans-serif",
    },
  },

  success: "#00c853",
  error: "#b71c1c",
};
